module.exports = __webpack_public_path__ + "static/media/osm-topo.e976efdf.jpg";